import { isOneOfTags, isElementNode } from 'anodum';
import disable from './disable';
import canBeRichEdited from '../../../constraints/verifiers/can-be-rich-edited';
import canBeSimpleEdited from '../../../constraints/verifiers/can-be-simple-edited';
import getContenteditableAttributeValue from '../../utils/helpers/webkit-workarounds/get-contenteditable-attribute-value';

const TEXT_ATTRIBUTE = 'data-ws-text';
const CONTENTEDITABLE = 'contenteditable';
const NON_EDITABLE_TAGS = ['body', 'html', 'script', 'style', 'label', 'title'];

const canBeEdited = (node) => {
  if (isOneOfTags(node, NON_EDITABLE_TAGS)) return false;

  if (canBeRichEdited(node) || canBeSimpleEdited(node)) return true;

  return false;
};

const apply = (node) => {
  if (!isElementNode(node) || disable.isDisabledNode(node)) return;

  if (canBeEdited(node)) {
    const contenteditableValue = getContenteditableAttributeValue(node);

    node.setAttribute(TEXT_ATTRIBUTE, true);
    node.setAttribute(CONTENTEDITABLE, contenteditableValue);
  }
};

const remove = (node) => {
  if (isElementNode(node) && node.matches(`[${TEXT_ATTRIBUTE}]`)) {
    node.removeAttribute(TEXT_ATTRIBUTE);
    node.removeAttribute(CONTENTEDITABLE);
  }
};

const shouldPreserveAttribute = (attribute) =>
  attribute.name === TEXT_ATTRIBUTE || attribute.name === CONTENTEDITABLE;

const getRootTextElement = (element) => {
  let currentNode = element.closest(`[${TEXT_ATTRIBUTE}]`);
  let rootNode = null;

  while (currentNode) {
    rootNode = currentNode;

    currentNode = currentNode.parentElement;
    if (!currentNode) break;
    currentNode = currentNode.closest(`[${TEXT_ATTRIBUTE}]`);
  }

  return rootNode;
};

export default {
  apply,
  remove,
  shouldPreserveAttribute,
  getRootTextElement,
  TEXT_ATTRIBUTE,
};
